export const events = [
  {
    type: "Baby Shower",
    theme: "She's Ready to Pop 🫧",
  },
  {
    type: "Baby Shower",
    theme: "Mario Party 🍄",
  },
  {
    type: "Graduation Party",
    theme: "Black & White Glam 🎓",
  },
  {
    type: "Graduation Party",
    theme: "Maroon Paw-ty  🐾",
  },
  {
    type: "Graduation Party",
    theme: "Black & Pink 🌸",
  },
  {
    type: "Baby Shower",
    theme: "Coquette 🎀",
  },
  {
    type: "Wedding",
    theme: "Lilac in Love 💍",
  },
  {
    type: "Baby Shower",
    theme: "Baby in Bloom 🪻",
  },
  {
    type: "Graduation Party",
    theme: "Glamorous & Grand 👛",
  },
  {
    type: "Baby Shower",
    theme: "Over the Moon 🌙",
  },
  {
    type: "Graduation Party",
    theme: "Black & Red 🎓",
  },
  {
    type: "Baby Shower",
    theme: "Welcome Little Duckling! 🐣",
  },
  {
    type: "Graduation Party",
    theme: "Class of 2025! 🌹",
  },
  {
    type: "Birthday Party",
    theme: "Blue & Gold 💙",
  },
  {
    type: "Graduation Party",
    theme: "Knocked it Out of the Park! ⚾️",
  },
  {
    type: "Wedding",
    theme: "Emerald Elegance 💍",
  },
  {
    type: "Celebrations",
    theme: "In Bloom 🌺",
  },
  {
    type: "Baby Shower",
    theme: "It's a Girl! 🌸",
  },
  {
    type: "Baby Shower",
    theme: "We Can Bearly Wait 🧸",
  },
  {
    type: "Graduation Party",
    theme: "Rosy Carnations 🌹",
  },
  {
    type: "Graduation Party",
    theme: "Golden Grad 💛",
  },
  {
    type: "Graduation Party",
    theme: "Green & Gold 💚",
  },
  {
    type: "Wedding",
    theme: "Lavender Love 🪻",
  },
];

export const imageIds = [
  // List each subarray with their corresponding public IDs here
  // baby-shower-ready-to-pop
  [
    "IMG_3334_ctauhp",
    "IMG_3361_hwlw2e",
    "IMG_3312_kwfmau",
    "IMG_3326_ueodte",
    "IMG_3331_ag5bda",
  ],
  // baby-shower-mario-party
  [
    "entry_sign_llccnd",
    "backdrop_lh2a3a",
    "centerpiece_2_lxdkio",
    "entry_balloons_copy_pj47ze",
    "centerpiece_3_ovlyhu",
  ],
  // graduation-black-and-white-glam
  [
    "IMG_2637_alktwy",
    "IMG_2638_frw6wu",
    "IMG_2744_lmpyex",
    "IMG_2755_l5174t",
    "IMG_2749_kjxu4s",
  ],
  // graduation-maroon-wildcat
  [
    "IMG_2619_jy72oq",
    "cutout_neon3_smhqhb",
    "table_backdrop_oeueuk",
    "centerpiece1_kkegvo",
    "backdrop_lit_suhhox",
  ],
  // graduation-black-and-pink
  [
    "IMG_2520_cveyy9",
    "IMG_2515_ut08ql",
    "IMG_2513_ty4qt9",
    "IMG_2532_nqhc6e",
    "IMG_2512_ikdku4",
  ],
  // baby-shower-coquette
  [
    "IMG_1736_eonytf",
    "IMG_1797_c5atoq",
    "IMG_1806_lcbnqk",
    "IMG_1812_mobmng",
    "IMG_1845_wpshtn",
  ],
  // wedding-lilac-in-love
  [
    "event276_a0f57v",
    "venue_white12-2_ob6hdv",
    "event279_rn9yfx",
    "event282_mevumc",
    "event280_xy9ooi",
  ],
  // babyshower-baby-in-bloom
  [
    "event223_egvnuh",
    "event226_qhelzr",
    "event224_ak5wuc",
    "event222_ybwuks",
    "event225_qomtta",
  ],
  // graduation-pink
  [
    "event228_ljyxgc",
    "event230_qqdnff",
    "event231_x3nqdu",
    "event234_tjllx4",
    "event233_whl7br",
    "event232_mzim3z",
  ],
  // babyshower-over-the-moon
  [
    "event217_hsmd65",
    "event219_yjxdy7",
    "event218_zz3qlw",
    "event220_jrv1vi",
    "event221_lrnvpc",
  ],
  // graduation-red-black
  [
    "event260_kcs1lr",
    "event255_ralmlc",
    "event254_q8p7va",
    "event256_vwbapy",
    "event261_vrkvf3",
    "event257_scvxro",
  ],
  // babyshower-duckling
  [
    "event248_ema22o",
    "event245_w1m8fh",
    "event246_q7tavt",
    "event251_aghsky",
    "event250_vsxiht",
  ],
  // graduation-2025
  [
    "event235_nsfoez",
    "event236_esab32",
    "event241_ii4cgm",
    "event240_b8zemw",
    "event238_zwtmfj",
    "event239_c7iwvm",
  ],
  // birthday-blue-gold
  [
    "event263_sz7lwe",
    "event267_mxrbek",
    "event264_s7z0gg",
    "event265_wgzvpd",
    "event267_mxrbek",
  ],
  // graduation-baseball
  [
    "event275_po64f7",
    "event269_wlxya8",
    "event268_dgv1bp",
    "event271_sxmsxb",
    "event272_x8ktqo",
  ],
  // wedding-teal
  [
    "event287_bqpa3p",
    "event293_o9kog2",
    "event284_tk9uuh",
    "event294_r2k2cd",
    "event288_xbri6l",
    "event296_wost2o",
  ],
  // special-event-in-bloom
  ["event298_jft6pi", "event300_d6dtwo", "event297_yqtgsv", "event298_jft6pi"],
  // baby-shower-girl
  [
    "event301_cwk4o5",
    "event303_xlavi4",
    "event305_kcmpoz",
    "event306_sys96u",
    "event308_tjjokr",
  ],
  // baby-shower-bear
  [
    "event187_wg16sm",
    "event61_asdfd",
    "event71_mobfhz",
    "event75_fgkkua",
    "event80_ibp8zx",
    "event190_pneamr",
  ],
  // graduation-maroon
  ["event110_mehkn0", "event77_ox9tz9", "event112_vufzau", "event113_aaghjw"],
  // graduation-yellow-floral
  ["event85_xytx9t", "event118_myk83n", "event119_jcuj2h", "event120_m8467c"],
  [
    "event104_fkvmsc",
    "event79_g9d3bt",
    "event100_ditqxp",
    "event105_t92oz4",
    "event101_rkt3bb",
    "event102_pvjpas",
  ],
  // wedding-lavender
  [
    "wedding_lavender2",
    "wedding_lavender",
    "wedding_lavender4",
    "wedding_lavender1",
    "wedding_lavender5",
    "wedding_lavender3",
  ],
];
